import React from "react";

export default function YouTube({
  videoId,
  opts
}) {
  return (
    <div>
      <iframe
        title="Youtube video"
        style={{
          width: opts.width,
          height: opts.height
        }}
        src={`https://www.youtube.com/embed/${videoId}?modestbranding=1`}
        srcdoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${videoId}?autoplay=1><img src=https://img.youtube.com/vi/${videoId}/hqdefault.jpg><span>▶</span></a>`}
        frameBorder="0"
      />
    </div>
  );
}